import { MethodItem } from './types';

// TODO: update images
export const overview: Omit<MethodItem, 'image'>[] = [
  {
    heading: 'Activate Your<br/>Subscription',
    copy: 'To become a Partner, you must have an active subscription to 28. You can activate your subscription at 28.co/subscribe. This gives you full access to all features and content in the app. ',
  },
  {
    heading: 'Visit<br/>Your Portal',
    copy: 'You will be granted access to your own portal, which is where your custom shareable link and code will be stored. You can view your earnings, see every member of your community, and set payout preferences.',
  },
  {
    heading: 'Review Partner<br/>Materials',
    copy: 'You will be sent an educational PDF that explains the science of the menstrual cycle, benefits of syncing your cycle, the 28 method, all the features and content within the app, your compensation structure, and more. ',
  },
  {
    heading: 'Start<br/>Earning',
    copy: 'You’re ready to build your community and earn income! Share your code or link IRL and across social media. It’s time to walk the walk and talk the talk. Inspire and educate others with your transformation. ',
  },
];
